import React from "react"
import { Container } from "@carrotfertility/carotene"
import { StateMachineStepView, StateMachineProvider } from "components/context/stateMachine/StateMachineV2"
import { Modal } from "components/views/modal/Modal"
import { reimbursementSection } from "./workflow/step-library"
import { ReimbursementProvider } from "components/context/reimbursement/GetReimbursedContext"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"

const GetReimbursed = ({ expenseId = null, transDate = null, transAmount = null, onExit }): JSX.Element => {
  return (
    <StateMachineProvider
      initialSection="ReimbursementSection"
      stateMachineDescription={[reimbursementSection]}
      onComplete={() => {}}
    >
      <ReimbursementProvider expenseId={expenseId} transDate={transDate} transAmount={transAmount} onExit={onExit}>
        <EmployeeOnlyModalContainer onClose={onExit}>
          <Modal titleText={`Get reimbursed`} onExit={onExit}>
            <Container paddingLeftRight="huge">
              <StateMachineStepView />
            </Container>
          </Modal>
        </EmployeeOnlyModalContainer>
      </ReimbursementProvider>
    </StateMachineProvider>
  )
}

export { GetReimbursed }
